import React from 'react';
import './LoadingOverlay.css';

interface Props {
  isVisible: boolean;
  message?: string;
}

const LoadingOverlay: React.FC<Props> = ({ isVisible, message = '불러오는 중...' }) => {
  if (!isVisible) return null;
  return (
    <div className="loading-overlay" role="status" aria-live="polite">
      <div className="loading-overlay-content">
        <div className="loading-overlay-spinner" />
        <span>{message}</span>
      </div>
    </div>
  );
};

export default LoadingOverlay;

